import { configureStore } from "@reduxjs/toolkit";
import ThemeSlice from "./slice/ThemeSlice";
import SlideToggleSlice from "./slice/SlideToggleSlice";
import { GetUserProfileSlice, IsUpdateProfile, handelProfileImage } from "./slice/UserProfileSlice";
import { GetAllRoleSlice, CheckSingleRolePermissonSlice, GetSingleRoleSlice } from "./slice/RoleSliceAction";
import SearchSlice from "./slice/SearchSlice";
import ConformationBoxSlice from "./slice/ConformationToggle";
import { GetAllUserSlice, GetSingleUserSlice } from "./slice/UserSliceAction";
import { GetAllMenuSlice, GetAllParentMenuSlice, GetSingleMenuSlice } from "./slice/MenuSliceActions";
import { GetAllCallDispositionSlice, GetSingleCallDispositionSlice } from "./slice/CallDisposition";
import { GetProductDetialsSlice, GetProductsSlice } from "./slice/ProductSlice";
import { GetAllCallSlice, GetCallDetialsSlice, GetCallHistorySlice,  } from "./slice/Callslice";
import { GetAllOperatingSystemSlice, OperatingSystemSlice } from "./slice/OperatingSystemSlice";
import { GetCallSPermissionSlice } from "./slice/CallPerMiassion";
import { GetAllCustomerSlice, SearchCustomerSlice } from "./slice/CustomerSlice";
import { GetInvioceDetail, GetInvioceSlice, GetInvioceSubSlice } from "./slice/InvioceActionSlice";
import { PaymentAllSlice, PaymentMerchantDetailsSlice } from "./slice/PaymentAction";
import { GetAllStatusMasterSlice, StatusMasterDetailsSlice } from "./slice/StatusMasterSlice";
import { CheckDeviceWhiteListedSlice, GetIpAddressSecurtySlice, GetIpDeviceAddressDetails } from "./slice/IpDeviceSecurty";
import { GetknowledgeBaseDetails, GetknowledgeBaseSlice } from "./slice/knowledgeBaseSlice";
import { ChatUserDetailSlice, GetAllChatHistorySlice, GetAllChatUserSlice } from "./slice/ChatSlice";


const store = configureStore({
    reducer: {
        Theme: ThemeSlice,
        Search: SearchSlice,
        conformation: ConformationBoxSlice.reducer,
        SlideSidebar: SlideToggleSlice,
        UserProfile: GetUserProfileSlice.reducer,
        isOenProfileBox: IsUpdateProfile.reducer,
        ViewPrevImage: handelProfileImage.reducer,
        RolePermission: CheckSingleRolePermissonSlice.reducer,
        UserRoles: GetAllRoleSlice.reducer,
        Role: GetSingleRoleSlice.reducer,
        Users: GetAllUserSlice.reducer,
        User: GetSingleUserSlice.reducer,
        Menus: GetAllMenuSlice.reducer,
        ParentMenu: GetAllParentMenuSlice.reducer,
        Menu: GetSingleMenuSlice.reducer,
        CallDispositions: GetAllCallDispositionSlice.reducer,
        CallDisposition: GetSingleCallDispositionSlice.reducer,
        Products: GetProductsSlice.reducer,
        Product: GetProductDetialsSlice.reducer,
        Calls: GetAllCallSlice.reducer,
        Call: GetCallDetialsSlice.reducer,
        SearchCustomer: SearchCustomerSlice.reducer,
        CallHistory: GetCallHistorySlice.reducer,
        CallsPermissionBy: GetCallSPermissionSlice.reducer,
        OperatingSystem: GetAllOperatingSystemSlice.reducer,
        OperatingSystemDetail: OperatingSystemSlice.reducer,
        // --------GetAllCustomerSlice --------
        Customers: GetAllCustomerSlice.reducer,
        // invioce --------
        Invioces: GetInvioceSlice.reducer,
        InvioceDetial: GetInvioceDetail.reducer,
        SubInvioce: GetInvioceSubSlice.reducer,

        // payment -----
        Payment: PaymentAllSlice.reducer,
        PaymentMerchantDetail: PaymentMerchantDetailsSlice.reducer,
        
        // StatusMaster -----
        StatusMaster: GetAllStatusMasterSlice.reducer,
        StatusMasterDetsil: StatusMasterDetailsSlice.reducer,

        // ip address -----
        IpAddress: GetIpAddressSecurtySlice.reducer,
        DeviceIp: GetIpDeviceAddressDetails.reducer,
        IpPermisson: CheckDeviceWhiteListedSlice.reducer,

        // knowledgeBase -----
        knowledgeBaseAll: GetknowledgeBaseSlice.reducer,
        knowledgeBaseDetails: GetknowledgeBaseDetails.reducer,

        // chat store -----
        ChatHistory: GetAllChatHistorySlice.reducer,
        ConnectionUser: GetAllChatUserSlice.reducer,
        ChatUser: ChatUserDetailSlice.reducer,
    }
})

export default store
